import { Component, inject, ViewChild } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { DatePipe } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { IUser } from '../../../../user/model/user.model';
import { Location } from '@angular/common';
import { ToastService } from '../../../../shared/services/toast.service';
import { ToastrService } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CalendarModule } from 'primeng/calendar';
import { LanguageService } from '../../../../shared/services/language.services';
import { ICourse } from '../../../models/course.model';
import { CourseModuleService } from '../../../../courseModule/services/courseModule.service';
import { ICourseModule } from '../../../../courseModule/models/courseModule.model';
import { CourseModuleListComponent } from '../courseModuleList/courseModuleList.component';
import { Store } from '@ngrx/store';
import { getCourse } from '../../../store/course.actions';

@Component({
    selector: 'clp-course-module-data',
    styleUrls: ['./courseModuleData.component.scss'],
    templateUrl: './courseModuleData.component.html',
    imports: [
    RouterModule,
    TranslateModule,
    ReactiveFormsModule,
    CalendarModule,
    CourseModuleListComponent
],
    providers: [
        CourseModuleService,
        ToastrService,
        DatePipe,
        BrowserAnimationsModule,
        LanguageService
    ]
})
export class ModulesDataComponent {
    private _location = inject(Location);
    private courseModuleService = inject(CourseModuleService);
    private toastService = inject(ToastService);
    private translate = inject(TranslateService);
    private route = inject(ActivatedRoute);
    private store = inject(Store);

    courses: ICourse[] = [];
    courseModuleForm!: FormGroup;
    courseModule$!: Observable<ICourseModule>;
    courseId!: string | null;
    edit: boolean = false;
    user$!: Observable<IUser>;
    nextOrder$! : Observable<number>;

    @ViewChild(CourseModuleListComponent) courseModuleListComponent!: CourseModuleListComponent;


    ngOnInit(): void {
        this.courseId = this.route.snapshot.paramMap.get('id');
        this.edit = false;

        this.courseModuleForm = new FormGroup({
            id: new FormControl(''),
            courseId: new FormControl(''),
            title: new FormControl('', [Validators.maxLength(65)]),
            order: new FormControl(''),
        });

        this.loadDefaultOrder();
    }


    changeCourseModule(formValues: any) {
        if (!this.courseModuleForm.invalid) {
            const courseModule: ICourseModule = {
                ...formValues,
                courseId: this.courseId === '' ? null : this.courseId,
                id: formValues.id === '' ? null : formValues.id
            };

            let return$: Observable<ICourseModule>;
            if (!this.edit) {
                return$ = this.courseModuleService.createCourseModule(courseModule);
                // For some reason, the subscribe is not working outside the if block
                return$.subscribe(_ => {
                  if (this.courseId !== undefined && this.courseId !== null && this.courseId !== '') {
                    this.store.dispatch(getCourse(this.courseId));
                    this.clearForm(true);
                  }
                });
            } else {
                return$ = this.courseModuleService.editCourseModule(courseModule)
                // For some reason, the subscribe is not working outside the if block
                return$.subscribe(_ => {
                  if (this.courseId !== undefined && this.courseId !== null && this.courseId !== '') {
                    this.store.dispatch(getCourse(this.courseId));
                    this.clearForm(true);
                  }
                });
            }
        } else {
            this.courseModuleForm.markAllAsTouched();
        }
    }

    clearForm(loadDefaultOrder: boolean = false) {
      this.courseModuleForm.patchValue({
          id: null,
          courseId: null,
          title: null,
          order: null
      });
      this.courseModuleForm.markAsPristine();
      this.courseModuleForm.markAsUntouched();
      this.edit = false;
      if (loadDefaultOrder) {
        this.loadDefaultOrder();
      }
    }

    editCourseModule(module: ICourseModule) {
        this.courseId = module.courseId ?? null;
        this.edit = true;
        this.courseModuleForm.patchValue({
            id: module.id,
            courseId: module.courseId,
            title: module.title,
            order: module.order
        });
    }

    backClicked() {
        this._location.back();
    }

    private loadDefaultOrder(): void {
      this.nextOrder$ = this.courseModuleService.getNextOrder();
      this.nextOrder$.subscribe(order => {
          this.courseModuleForm.patchValue({
              order: order
          });
      });
    }
}
